.toggleButton {
  min-height: 48px;
}
